import { useNavigate } from "react-router-dom";
import { useFoxTopUpStore } from "./store";
import { TopUpContainer, TopUpPageContainer, UserInfoContainer } from "./atom";
import { useInitTabList } from "./hooks/useInitTabList";
import { TopUpTabs } from "@/components/top-up/components/tabs";
import { FoxUserInfoBar } from "./components/user-info-bar";
import { useGlobalStore } from "@/store/GlobalStore";
import TopAdvertiseModule from "@/components/top-up/components/top-advertise-module";

export function FoxTopUp() {
  const { isZh } = useGlobalStore();
  const { getTabsList } = useInitTabList();
  const navigate = useNavigate();
  const { activeName, setter: setFoxTopUpStore } = useFoxTopUpStore();

  return (
    <TopUpPageContainer>
      {/* 顶部广告 */}
      <TopAdvertiseModule
        activeName={activeName}
        isZh={isZh}
        imageUrlLink={
          getTabsList().find((item) => item.key === activeName)?.advertiseImg
        }
        imageUrlLinkEventDetails={
          getTabsList().find((item) => item.key === activeName)?.advertiseLink
        }
      />
      <TopUpContainer>
        <TopUpTabs
          isForeign
          // TopUpPageContainer 解决使用相同包含svg组件 切换tab时svg不展示
          destroyInactiveTabPane
          tabsList={getTabsList()}
          activeKey={activeName}
          onChange={(k) => {
            setFoxTopUpStore((state) => {
              state.activeName = k;
            });
            navigate(`/topUp?activeName=${k}`);
          }}
        />
        <UserInfoContainer>
          <FoxUserInfoBar />
        </UserInfoContainer>
      </TopUpContainer>
    </TopUpPageContainer>
  );
}
